const state = {
  isLoading: false,
  data: {
    orderable: {},
  },
  // Original send_charge from database, preserved during edit session
  originalSendCharge: null,
};

export default state;
